export default "__VITE_ASSET__Da67YuQq__"